import { render, staticRenderFns } from "./ImageList.vue?vue&type=template&id=b22a3c1a&scoped=true&"
import script from "./ImageList.vue?vue&type=script&lang=js&"
export * from "./ImageList.vue?vue&type=script&lang=js&"
import style0 from "./ImageList.vue?vue&type=style&index=0&id=b22a3c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22a3c1a",
  null
  
)

export default component.exports